import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function Loading({text='Carregando dados...'}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",   // controla o quanto ele desce
        gap: 1
      }}
    >
      <CircularProgress size={50} thickness={4} />

      <Typography variant="body2">
        { text}
      </Typography>
    </Box>
  );
}

export default Loading;